const DEFAULTS = {
  title: document.title,
  description: '',
}

const getMetaContent = name => {
  const tag = document.head.querySelector(
    `meta[name="${name}"], meta[property="${name}"]`,
  )

  return tag ? tag.getAttribute('content') || '' : ''
}

DEFAULTS.description = getMetaContent('description')

const ensureMetaTag = (attr, value) => {
  let tag = document.head.querySelector(`meta[${attr}="${value}"]`)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, value)
    document.head.appendChild(tag)
  }

  return tag
}

const setMeta = (attr, value, content) => {
  const tag = ensureMetaTag(attr, value)
  tag.setAttribute('content', content || '')
}

export const applyRequestMeta = ({
  title,
  description,
  image,
  url,
}) => {
  document.title = title || DEFAULTS.title

  setMeta('name', 'description', description || DEFAULTS.description)

  setMeta('property', 'og:type', 'website')
  setMeta('property', 'og:title', title || DEFAULTS.title)
  setMeta('property', 'og:description', description || DEFAULTS.description)
  setMeta('property', 'og:image', image || '')
  setMeta('property', 'og:url', url || window.location.href)

  setMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary')
  setMeta('name', 'twitter:title', title || DEFAULTS.title)
  setMeta('name', 'twitter:description', description || DEFAULTS.description)
  setMeta('name', 'twitter:image', image || '')
}

export const resetRequestMeta = () => {
  document.title = DEFAULTS.title

  setMeta('name', 'description', DEFAULTS.description)

  setMeta('property', 'og:type', 'website')
  setMeta('property', 'og:title', DEFAULTS.title)
  setMeta('property', 'og:description', DEFAULTS.description)
  setMeta('property', 'og:image', '')
  setMeta('property', 'og:url', window.location.href)

  setMeta('name', 'twitter:card', 'summary')
  setMeta('name', 'twitter:title', DEFAULTS.title)
  setMeta('name', 'twitter:description', DEFAULTS.description)
  setMeta('name', 'twitter:image', '')
}